import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const Separator = styled.div`
  width: 100%;
  height: 4px;
  flex-shrink: 0;
  background-color: ${Color.Grey50};
`
